import { render } from "./WebShopWarenKorb.vue?vue&type=template&id=08b23666&scoped=true&ts=true"
import script from "./WebShopWarenKorb.vue?vue&type=script&lang=ts"
export * from "./WebShopWarenKorb.vue?vue&type=script&lang=ts"

import "./WebShopWarenKorb.vue?vue&type=style&index=0&id=08b23666&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b23666"]])

export default __exports__